import { routerForReceiveDataFromFilters } from '@/core/filters/receiveDataFromFilters'

function getSearchAttributesFilter (searchAttributes) {
	var customAttributesTypes = {
		'status': 'status',
		'created': 'D',
		'updated': 'D',
		'id': 'S',
		'creator': 'S',
		'updater': 'S'
	}
	$('#search-controls').children().each(function () {
		var attributeName = $(this).attr('id')
		var attributeType = (itemStructure[attributeName]) ? itemStructure[attributeName]['type'] : customAttributesTypes[attributeName]
		var isMultiple = $(this).find('textarea').is('textarea')
		var filterData = routerForReceiveDataFromFilters(attributeType, attributeName, isMultiple)
		if (!_.isEmpty(filterData)) {
			searchAttributes[attributeName] = filterData
		}
	})
}

function getSearchPhraseAttributesFilter (searchAttributes) {
	var attributeName = $('.table_search_phrase').children().first().attr('id')
	var filterData = routerForReceiveDataFromFilters('S', attributeName, false)
	searchAttributes[attributeName] = {
		val: filterData.val ? filterData.val.trim() : filterData.val,
		type: filterData.type
	}
}

export function search (itemStructure, table) {
	var searchAttributes = {}
	based_search(searchAttributes)
}

export function searchPhrase () {
	var searchAttributes = {}
	based_search(searchAttributes)
	$('.table_search').removeClass('collapse')
	$('.table_search_phrase input').focus()
}

function based_search (searchAttributes) {
	getSearchAttributesFilter(searchAttributes)
	getSearchPhraseAttributesFilter(searchAttributes)
	table.setFilters(searchAttributes)
	table.currentPage = 1
	if (table.selectedItemsMode) {
		$('#table_toolbar_all').click()
	}
	table.saveFiltersState()
	table.saveTableState()
	table.initTable()
}
